// @ts-strict-ignore
import { UserProfileVO } from '@user/model/vo/user.vo';
import { JsonObject, JsonProperty } from '../convert/convert-core';

@JsonObject('SystemConfigurationVO')
export class SystemConfigurationVO {
    @JsonProperty('userProfile', 'UserProfileVO')
    public userProfile: UserProfileVO = undefined;

    @JsonProperty('adminToolsEnabled', 'Boolean')
    public adminToolsEnabled: boolean = undefined;

    @JsonProperty('debugToolsEnabled', 'Boolean')
    public debugToolsEnabled: boolean = undefined;

    @JsonProperty('loggingServicesEnabled', 'Boolean')
    public loggingServicesEnabled: boolean = undefined;

    @JsonProperty('versionNumber', 'String')
    public versionNumber: string = undefined;

    @JsonProperty('mainPage', 'String')
    public mainPage: string = undefined;

    @JsonProperty('url', 'String')
    public url: string = undefined;

    @JsonProperty('requestEmail', 'String')
    public requestEmail: string = undefined;

    @JsonProperty('requestMcsGdsEmail', 'String')
    public requestMcsGdsEmail: string = undefined;

    @JsonProperty('requestMarkingcardsEmail', 'String')
    public requestMarkingcardsEmail: string = undefined;

    @JsonProperty('priceCalculationLookupURL', 'String')
    public priceCalculationLookupURL: string = undefined;

    @JsonProperty('userActionsLoggingSynchronisationDelay', 'Number')
    public userActionsLoggingSynchronisationDelay: number = undefined;

    @JsonProperty('remoteCacheMaxSize', 'Number')
    public remoteCacheMaxSize: number = undefined;

    @JsonProperty('projectRenderingEnabled', 'Boolean')
    public projectRenderingEnabled: boolean = undefined;

    @JsonProperty('isArticleCatalogOutOfDate', 'Boolean')
    public isArticleCatalogOutOfDate: boolean = undefined;

    @JsonProperty('labelingScaleFactor', 'Number')
    public labelingScaleFactor: number = undefined;

    @JsonProperty('spacingDecidingValue', 'Number')
    public spacingDecidingValue: number = undefined;

    @JsonProperty('internalEmailPostfix', 'String')
    public internalEmailPostfix: string = undefined;

    @JsonProperty('requestDaysInFuture', 'Number')
    public requestDaysInFuture: number = undefined;

    @JsonProperty('elbridgeInterfaceURL', 'String')
    public elbridgeInterfaceURL: string = undefined;

    @JsonProperty('userActionsLoggingEnabled', 'Boolean')
    public userActionsLoggingEnabled: boolean = false;

    @JsonProperty('pdmExportActive', 'Boolean')
    public pdmExportActive: boolean = false;

    @JsonProperty('priceCalculationActive', 'Boolean')
    public priceCalculationActive: boolean = false;

    @JsonProperty('plausicheckActive', 'Boolean')
    public plausicheckActive: boolean = false;

    @JsonProperty('webshopActive', 'Boolean')
    public webshopActive: boolean = false;

    @JsonProperty('cdcEnabled', 'Boolean')
    public cdcEnabled: boolean = false;

    @JsonProperty('cdcApiKey', 'String')
    public cdcApiKey: string = undefined;

    @JsonProperty('cdcApiDomain', 'String')
    public cdcApiDomain: string = undefined;

    @JsonProperty('cdcViewUserProfileUrl', 'String')
    public cdcViewUserProfileUrl: string = undefined;

    @JsonProperty('cdcRegisterUserUrl', 'String')
    public cdcRegisterUserUrl: string = undefined;

    @JsonProperty('localAuthenticationEnabled', 'Boolean')
    public localAuthenticationEnabled: boolean = false;

    @JsonProperty('cirqitUrl', 'String')
    public cirqitUrl: string = undefined;
}
